<template>
  <div class="loginMain">
    <div class="topText">推荐使用浏览器:火狐浏览器（Firefox）、GOOGLE浏览器（Chrome），IE内核的浏览器请作好兼容性设置</div>
    <div class="box">
      <div class="top">上海市既有建筑绿色更新改造评定申报系统</div>
      <div class="parent">
        <img src="../assets/user.png" />
        <div class="line"></div>
        <input placeholder="请输入您的账号" v-model="username" />
      </div>
      <div class="parent">
        <img src="../assets/password.png" />
        <div class="line"></div>
        <input placeholder="请输入您的密码" v-model="password" type="password" />
      </div>
      <div class="rememberPwd">
        <el-checkbox v-model="rememberPwd">记住密码</el-checkbox>
      </div>
      <div class="loginBtn">
        <el-button type="primary" @click="login" :loading="loading">登录</el-button>
      </div>
      <div class="register">
        <a href="http://117.74.136.106:18080/#/register" target="_blank">新用户注册</a>
      </div>
    </div>
  </div>
</template>

<script>
import { setUserInfo } from '../utils/cache'
import * as API from '../utils/apiService'

export default {
  data () {
    return {
      username: '',
      password: '',
      rememberPwd: true,
      loading: false
    }
  },
  mounted () {
    // 记住密码回显
    if (localStorage.getItem('username')) {
      this.username = localStorage.getItem('username')
    }
    if (localStorage.getItem('password')) {
      this.password = localStorage.getItem('password')
    }
    if (this.username && this.password) {
      this.rememberPwd = true
    }
  },
  methods: {
    login () {
      this.loading = true
      let params = {
        username: this.username,
        password: this.password
      }
      API.login(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.loading = false
          setUserInfo(resp.data)
          if (this.rememberPwd) {
            localStorage.setItem('username', this.username)
            localStorage.setItem('password', this.password)
          } else {
            localStorage.removeItem('username')
            localStorage.removeItem('password')
          }
          this.$store.commit('changeUserName', resp.data.username)
          this.$router.push('/introduce')
        } else {
          this.loading = false
          this.$message.error(resp.resultMsg)
        }
      })
    }
  }
}
</script>

<style lang="scss">
.loginMain {
  background-image: url("../assets/login.png");
  background-size: cover;
  width: 100%;
  height: 100%;
  position: relative;
  .topText {
    display: flex;
    justify-content: center;
    background: rgba(255, 255, 255, 0.5);
  }
  .box {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 572px;
    height: 432px;
    position: absolute;
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid #979797;
    border-radius: 12px;
    .top {
      background: #fff;
      border-radius: 12px 12px 0 0;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 87px;
      font-size: 24px;
      color: #0096cc;
      margin-bottom: 35px;
      font-weight: bold;
    }
    .parent {
      background: #ffffff;
      border: 1px solid #979797;
      border-radius: 7px;
      width: 357px;
      height: 57px;
      margin: 0 auto 23px;
      position: relative;
      img {
        float: left;
        margin-top: 15px;
        margin-left: 22px;
        width: 25px;
      }
      input {
        width: 266px;
        height: 55px;
        font-size: 14px;
        color: #333;
        line-height: 55px;
        border: none;
        outline: none;
        margin-left: 20px;
        border-radius: 7px;
      }
      .line {
        width: 1px;
        height: 33px;
        background: #979797;
        float: left;
        margin-top: 12px;
        margin-left: 20px;
      }
    }
    .rememberPwd {
      text-align: left;
      width: 357px;
      margin: auto;
      font-size: 12px;
    }
  }
  .loginBtn {
    width: 357px;
    height: 57px;
    margin: 18px auto;
    .el-button--primary {
      width: 100%;
      height: 100%;
      background: #0096cc;
      border-radius: 7px;
      font-size: 18px;
      font-weight: normal;
    }
  }
  .register {
    display: flex;
    justify-content: center;
    align-items: center;
    a {
      color: #7c7c7c;
      text-decoration: none;
      font-size: 14px;
      //cursor: pointer;
      font-weight: 400;
    }
  }
}
</style>
